import { api } from "../Api.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos equipamentos
 */
export class HistoricRequest {
    // Pega os dados gerais do equipamento
    async getmappingsGeneral(id: string, datainicio: string, datafim: string, page: number): Promise<any>{
        try {
            let response ={
                data: null
            }
            if(page){
                response = await api.get(`/mappings/geral/${id}/${datainicio}/${datafim}?page=${page}`);
            }else{
                response = await api.get(`/mappings/geral/${id}/${datainicio}/${datafim}`,
                    {timeout: 300000}
                );

            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados para o grafico
    async getmappingsGeneralGraph(id: string, datainicio: string, datafim: string): Promise<any>{
        try {
            const response = await api.get(`/mappings/geral/charts/${id}/${datainicio}/${datafim}`,
            {timeout: 300000});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados de analises
    async getmappingsAnalysis(id: string, datainicio: string, datafim: string, page: number): Promise<any>{
        try {
            let response ={
                data: null
            }
            if(page){
                response = await api.get(`/mappings/analysisMode/${id}/${datainicio}/${datafim}?page=${page}`);
            }else{
                response = await api.get(`/mappings/analysisMode/${id}/${datainicio}/${datafim}`);

            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados de modo de operação
    async getmappingsOperations(id: string, datainicio: string, datafim: string, page: number): Promise<any>{
        try {
            let response = await api.get(`/mappings/operationMode/${id}/${datainicio}/${datafim}?page=${page}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados de graficos das analises
    async getmappingsAnalysisGraph(id: string, datainicio: string, datafim: string): Promise<any>{
        try {
            const response = await api.get(`/mappings/analysisMode/charts/${id}/${datainicio}/${datafim}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega todos os dados do equipamento
    async getmappingsAll(id: string, datainicio: string, datafim: string, page: number): Promise<any>{
        try {
            let response ={
                data: null
            }
            if(page){
                response = await api.get(`/mappings/detailed/${id}/${datainicio}/${datafim}?page=${page}`);
            }else{
                response = await api.get(`/mappings/detailed/${id}/${datainicio}/${datafim}`);

            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os equipamentos que o usuário tem acesso
    async getEquipamentosByUser(): Promise<any>{
        try {
            const Equipamentos = await api.get(`/me/authorizedPocosAndReservatoriosAndGrouppingsSeparated`);
            return Equipamentos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os poços que o usuário tem acesso
    async getPocosByUser(): Promise<any>{
        try {
            const pocos = await api.get(`/me/authorizedPocos2`);
            return pocos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os dados em formato excel do equipamento
    async getExcel(id: string, datainicio: string, datafim: string, analysisMode: boolean, readingMode: boolean, methodOld: boolean, extension?: string): Promise<any>{
        const requestBody: any = {
            equipment: id,
            datainicio,
            datafim,
            analysisMode,
            methodOld,
        };

        if (methodOld === false) {
            requestBody.format = extension;
            requestBody.protected = readingMode;
        }
        
        try {
            const response = await api.post(`equipments/export/mappings/excel`, requestBody, {responseType: 'blob', timeout: 300000});
            return response;
        } catch (error: any) {
            console.log(error);
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestCities():Promise<any>{
        try {
            const response = await api.get('/me/authorizedCities');
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}